import { createTheme } from "@kaggle/core";
import { DarkModeContext, DarkModeProvider } from "@kaggle/sdk";
import { Portal as MuiPortal, ThemeProvider as MuiThemeProvider, createTheme as muiCreateTheme } from "@mui/material";
import { Portal as RmwcPortal } from "@rmwc/base";
import * as React from "react";
import { ThemeProvider } from "styled-components";
import { PortalRoot, PortalRootName } from "../Portal";
import { MaterialThemeProvider } from "./MaterialThemeProvider";
import { RMWCProvider } from "./RMWCProvider";
function setDocumentBackgroundColor(backgroundColor) {
    window.document.body.style.backgroundColor = backgroundColor;
}
/** Wires up theme providers and portals  */ export var KaggleThemeProvider = function(props) {
    return /*#__PURE__*/ React.createElement(DarkModeProvider, null, /*#__PURE__*/ React.createElement(DarkModeContext.Consumer, null, function(darkModeContext) {
        var kaggleTheme = props.themeOverride ? props.themeOverride : createTheme({
            themeName: darkModeContext.darkModeEnabled ? "dark" : "light"
        });
        // Hack: this is the earliest point we have access to the theme, so
        // we set the document body color here.
        setDocumentBackgroundColor(kaggleTheme.km.color.background.normal);
        return /*#__PURE__*/ React.createElement(RMWCProvider, null, /*#__PURE__*/ React.createElement(MaterialThemeProvider, {
            // Ensure this inherits height, to avoid things like b/243408386.
            style: {
                height: "inherit"
            }
        }, props.includeMui ? /*#__PURE__*/ React.createElement(MuiThemeProvider, {
            theme: muiCreateTheme()
        }, /*#__PURE__*/ React.createElement(ThemeProvider, {
            theme: kaggleTheme
        }, /*#__PURE__*/ React.createElement(MuiPortal, null), /*#__PURE__*/ React.createElement(RmwcPortal, null), /*#__PURE__*/ React.createElement(PortalRoot, {
            name: PortalRootName.GLOBAL
        }), props.children)) : /*#__PURE__*/ React.createElement(ThemeProvider, {
            theme: kaggleTheme
        }, /*#__PURE__*/ React.createElement(RmwcPortal, null), /*#__PURE__*/ React.createElement(PortalRoot, {
            name: PortalRootName.GLOBAL
        }), props.children)));
    }));
};
